import { push } from "connected-react-router";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import { resetMRAApplication } from "../../redux/slice/primaryAgencyApplicationSlice";

export const PrivacyNoticeView = ({ setIsError }) => {
  const dispatch = useDispatch();
  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    dispatch(resetMRAApplication());
  }, [dispatch]);

  const checkCookiesEnabled = () => {
    try {
      var cookieEnabled = navigator.cookieEnabled;
      if (!cookieEnabled) {
        document.cookie = "testcookie";
        cookieEnabled = document.cookie.indexOf("testcookie") !== -1;
        if (cookieEnabled) {
          return true;
        } else {
          setErrMsg("privacy_notice.enable_cookies");
        }
      }
      return cookieEnabled;
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const privacyNext = async () => {
    try {
      if (checkCookiesEnabled()) {
        const url = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_COMPLETED_REG_PROGRAM_QUESTION}`;
        dispatch(push(url));
        // dispatch(screenLoadingAction())
        // dispatch(getServiceAvailableAction())
        //   .then((res) => {
        //     if (!res['data'] || !res.data.returnStatus) {
        //       setErrMsg('privacy_notice.service_not_available_error')
        //       dispatch(screenLoadingAction())
        //       return;
        //     }

        //     dispatch(registerAndLogin())
        //       .then(() => {
        //         dispatch(screenLoadingAction())
        //         history.push(`/${i18n.language}${t('routes.fines_question')}`)
        //       })
        //       .catch((e) => {
        //         dispatch(screenLoadingAction())
        //         console.log(e)
        //         setErrMsg('privacy_notice.server_error')
        //       })
        //   }).catch(err => {
        //     console.error(err)
        //     setErrMsg('privacy_notice.service_not_available_error')
        //     dispatch(screenLoadingAction())
        //   })
      }
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  const cancelURL = ROUTE_PATH.LAUNCHPAGE_MORTGAGE;

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1 style={{ margin: "2rem 0" }}>Privacy Notice</h1>
          <p>
            The Business and Consumer Services Division collects your personal
            information (such as your name, address, email, phone, criminal
            check, and work history etc.) as authorized by the Freedom of
            Information and Protection of Privacy Act and the Nova Scotia
            Mortgage Regulation Act.
          </p>

          <p>
            {" "}
            We use your personal information to:
            <ul>
              <li>Determine your eligibility for a licence.</li>
              <li>
                Provide the online service, process your application, and issue
                your license.
              </li>
              <li>Contact you if necessary.</li>
              <li>Process your payment and issue you a receipt.</li>
              <li>
                Create and maintain a public registry or registers of mortgage
                lenders, mortgage brokerages, mortgage brokers, associate
                mortgage brokers and mortgage administrators in compliance with
                section 7 of the Mortgage Regulation Act.
              </li>
              <li>
                Administer all of the Mortgage Regulation Act's regulatory
                requirements and to provide you with high-quality services.
              </li>
            </ul>
          </p>
          <p>
            We use and disclose your personal information for the purposes
            described above. We may only use or disclose your information for
            another purpose if we are authorized by law to do so, or if we
            obtain your consent.
          </p>
          <p>
            By submitting your application or making any other request to us (by
            contacting us via any of our official channels), you acknowledge
            that you understand the collection, use, and disclosure of any
            personal information you provide to us for the purpose of processing
            your application or request.
            {/* <a
              target="_blank"
              rel="noopener noreferrer"
              href={
                i18n.language === 'en' ? 'https://beta.novascotia.ca/privacy' : 'https://beta.novascotia.ca/fr/enonce-de-confidentialite'
              }
            >
              {' '}
              {t('privacy_notice.privacy_statement_link')}
              <span className="ns-visually-hidden">{t('shared.opens_new_tab')}</span>
            </a>.
            {t('privacy_notice.para3')}
            <a href="mailto:askus@novascotia.ca">{t('privacy_notice.ask_novascotia')}</a>. */}
          </p>
          <p>
            To read more about how government respects your privacy when
            interacting with us review our&nbsp; 
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={"https://beta.novascotia.ca/privacy?_ga=2.232773727.1752678722.1630322211-167856753.1610051975 "}
            >
              full privacy statement 
            </a>&nbsp;
            (opens in a new tab). For questions about how your personal information is
            handled by the Business and Consumer Services program, you may
            contact Business Licensing at 902-424-5552.
          </p>
        </div>
      </div>
      <div className="form-group has-error">
        <button
          className="btn-lg btn-default"
          style={{ marginBottom: errMsg === "" ? "" : "5px" }}
          onClick={privacyNext}
          value={"Continue"}
          name={"Continue"}
        >
          {"Continue"}
        </button>{" "}
        <a style={{ marginLeft: "4rem" }} href={cancelURL}>
          Cancel
        </a>
        {errMsg === "" ? (
          ""
        ) : (
          <i className="fa fa-exclamation-circle" aria-hidden="true" />
        )}
        <div className="help-block">{errMsg}</div>
      </div>
    </div>
  );
};
